import LatestReadings from './LatestReadings';

export default LatestReadings;
